import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { togglePopover } from '../../redux/Slices/popoverSlice';
import useOutsideClick from '../../hooks/useOutsideClick';
import { getContentById } from '../../redux/ContentRegistry/popover';
import usePopoverPositionUpdater from '../../hooks/usePopoverPositionUpdater';
import './Popover.scss';
import KeyboardBackspace from '../icons/KeyboardBackspace';
import Close from '../icons/Close';
import useHandlePopoverClick from '../../hooks/useHandlePopoverClick';

const PopOver = () => {
    const { isVisible, contentId, position, targetId, props } = useSelector((state) => state.popover);

    const { isBack, card, cardId, backPopover } = props;

    const dispatch = useDispatch();
    const popoverRef = useRef();

    const { handlePopoverClick } = useHandlePopoverClick();


    useOutsideClick(popoverRef, () => {
        dispatch(togglePopover({ contentId: null, position: { top: 0, left: 0 }, targetId: null }));
    });


    usePopoverPositionUpdater(targetId, popoverRef);


    if (!isVisible) {
        return null;
    }

    const content = getContentById(contentId, props);

    const isClosed = props.isClosed !== undefined ? props.isClosed : true;

    return (
        <div
            className="zoobbe-popover"
            style={{ top: position.top, left: position.left }}
            ref={popoverRef}
            id={contentId}
        >
            {
                isClosed && (
                    <div className="zoobbe-popover__header">
                        {
                            isBack && (
                                <button className="back-button"
                                    id={`popover-back-${backPopover}`}
                                    onClick={(e) => handlePopoverClick(e, backPopover, { ...props, isBack: false, isPopPositionChanged: false })}
                                >
                                    <KeyboardBackspace size={26} />
                                </button>
                            )
                        }
                        <button
                            className="zoobbe-popover__close-btn"
                            onClick={() => {
                                dispatch(togglePopover({ contentId: null, position: { top: 0, left: 0 }, targetId: null }));
                            }}
                        >
                            <Close color='#e3e3e3' size={18} />
                        </button>
                    </div>
                )
            }

            <div className="zoobbe-popover__content">
                {content}
            </div>
        </div>
    );
};

export default PopOver;
